import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './PaymentTermsModal.css';

/**
 * เงื่อนไขการรับชำระเงิน -- ของ "แพลตฟอร์ม" ไม่ใช่ของที่พัก
 *
 * ต่างจาก PolicyConfirmModal ที่แสดง terms_of_use ของแต่ละที่พักตอนกดจอง
 * ตัวนี้ตอบคำถามที่เกิดขึ้นเฉพาะตอนจ่ายเงินออนไลน์: เงินเข้าใคร ใครออกใบเสร็จ
 * ยกเลิกแล้วติดต่อใคร ข้อมูลบัตรเก็บที่ไหน -- ซึ่งเหมือนกันทุกที่พัก
 *
 * ทุกข้อเขียนจากพฤติกรรมจริงของระบบ ณ ตอนนี้ ไม่ใช่ข้อความสำเร็จรูป
 * ถ้าวันไหนเปลี่ยนวิธีรับเงินหรือเปิดการคืนเงินผ่านระบบ ต้องกลับมาแก้ที่นี่ด้วย
 *
 * ⚠️ ยังไม่ผ่านการตรวจจากนักกฎหมาย -- ใช้เพื่อเปิดระบบไปก่อน
 *    ส่วนที่ควรให้ทนายดูเป็นพิเศษคือข้อ "เงินเดินทางยังไง" และ "การยกเลิกและคืนเงิน"
 *    เพราะ once เป็นผู้รับเงินแทนที่พัก ไม่ใช่คู่สัญญาที่ให้บริการห้องพักเอง
 */

const PaymentTermsModal = ({ show, onHide }) => {
  const { t } = useTranslation();

  const sections = [
    'terms_pay_who',
    'terms_pay_flow',
    'terms_pay_receipt',
    'terms_pay_cancel',
    'terms_pay_card',
    'terms_pay_data',
    'terms_pay_contact',
  ];

  return (
    <Modal show={show} onHide={onHide} centered scrollable contentClassName="pay-terms">
      <Modal.Header closeButton>
        <Modal.Title>{t('terms_pay_title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="pay-terms__intro">{t('terms_pay_intro')}</p>

        {sections.map((key) => (
          <section className="pay-terms__section" key={key}>
            <h3>{t(`${key}_h`)}</h3>
            <p>{t(`${key}_b`)}</p>
          </section>
        ))}

        <p className="pay-terms__updated">{t('terms_pay_updated')}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="dark" onClick={onHide}>{t('close')}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PaymentTermsModal;
